module.exports = __webpack_public_path__ + "static/media/microsoft-5.f32b3f89.svg";